import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import { registerGdprCcpaGoodies } from 'javascripts/general_scripts'

registerGdprCcpaGoodies();